import React from "react";
import "../../App.css";

function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <p>
          &copy; <span id="current-year"></span> Quantum Care. All rights
          reserved. | Contact: info@quantumcare.mv
        </p>
      </div>
    </footer>
  );
}

export default Footer;
